// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IToken
 */
export interface IToken {
    /**
     * 
     * @type {string}
     * @memberof IToken
     */
    token_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IToken
     */
    status?: ITokenStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof IToken
     */
    issued_on?: number;
    /**
     * 
     * @type {number}
     * @memberof IToken
     */
    expires_in_seconds?: number;
    /**
     * 
     * @type {string}
     * @memberof IToken
     */
    public_key?: string;
    /**
     * 
     * @type {string}
     * @memberof IToken
     */
    algorithm?: string;
}

/**
* @export
* @enum {string}
*/
export enum ITokenStatusEnum {
    ACTIVE = 'ACTIVE',
    EXPIRED = 'EXPIRED'
}


/**
 * Check if a given object implements the IToken interface.
 */
export function instanceOfIToken(value: object): value is IToken {
    return true;
}

export function ITokenFromJSON(json: any): IToken {
    return ITokenFromJSONTyped(json, false);
}

export function ITokenFromJSONTyped(json: any, ignoreDiscriminator: boolean): IToken {
    if (json == null) {
        return json;
    }
    return {
        
        'token_id': json['tokenId'] == null ? undefined : json['tokenId'],
        'status': json['status'] == null ? undefined : json['status'],
        'issued_on': json['issuedOn'] == null ? undefined : json['issuedOn'],
        'expires_in_seconds': json['expiresInSeconds'] == null ? undefined : json['expiresInSeconds'],
        'public_key': json['publicKey'] == null ? undefined : json['publicKey'],
        'algorithm': json['algorithm'] == null ? undefined : json['algorithm'],
    };
}

export function ITokenToJSON(json: any): IToken {
    return ITokenToJSONTyped(json, false);
}

export function ITokenToJSONTyped(value?: IToken | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tokenId': value['token_id'],
        'status': value['status'],
        'issuedOn': value['issued_on'],
        'expiresInSeconds': value['expires_in_seconds'],
        'publicKey': value['public_key'],
        'algorithm': value['algorithm'],
    };
}

